import { postRequest } from '@/core';
import { preferredVendors } from '@/requests';

export default async function newPreferredVendorRequest(preferredVendor) {
	let url = preferredVendors.getPath();
	let response = await postRequest(url, {}, preferredVendor);
	return response;
}